import { render } from "./NutritionFacts.vue?vue&type=template&id=62c9ca5f&scoped=true"
import script from "./NutritionFacts.vue?vue&type=script&lang=js"
export * from "./NutritionFacts.vue?vue&type=script&lang=js"

import "./NutritionFacts.vue?vue&type=style&index=0&id=62c9ca5f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c9ca5f"],['__file',"resources/js/modules/product-categorization/components/filter/NutritionFacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62c9ca5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62c9ca5f', __exports__)) {
    api.reload('62c9ca5f', __exports__)
  }
  
  module.hot.accept("./NutritionFacts.vue?vue&type=template&id=62c9ca5f&scoped=true", () => {
    api.rerender('62c9ca5f', render)
  })

}


export default __exports__